/* Million Maguva — theme interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';

  /* ---- Drawer open/close (mobile menu + cart) ---- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawer(d) {
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { var d = closer.closest('.drawer'); if (d) closeDrawer(d); return; }
    if (e.target.classList && e.target.classList.contains('drawer__scrim')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.drawer[aria-hidden="false"]');
      if (open) closeDrawer(open);
    }
  });

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- AJAX add to cart (quick add + PDP) ---- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Re-render the cart drawer body from Section Rendering API HTML.
  function renderDrawerFromSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawerItems');
    var current = document.querySelector('#CartDrawerItems');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  async function syncCart() {
    try {
      var cart = await (await fetch(root + 'cart.js')).json();
      refreshCartCount(cart.item_count);
      return cart;
    } catch (err) { return null; }
  }

  /* ---- Product add-ons (blouse / fall+pico) ---- */
  function selectedAddons(form) {
    var out = [];
    form.querySelectorAll('input[data-addon-toggle]').forEach(function (toggle) {
      if (!toggle.checked) return;
      var box = document.getElementById(toggle.getAttribute('data-addon-toggle'));
      var pick = box && box.querySelector('input[data-addon-variant]:checked');
      if (pick) out.push(pick);
    });
    form.querySelectorAll('input[type="checkbox"][data-addon-variant]:checked').forEach(function (c) { out.push(c); });
    return out;
  }

  function updateAddonTotal(form) {
    var totalEl = form.querySelector('[data-addon-total]');
    if (!totalEl) return;
    var addons = selectedAddons(form);
    if (!addons.length) { totalEl.hidden = true; return; }
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var base = 0;
    var wrap = form.closest('[data-variant-selects]');
    var dataEl = wrap && wrap.querySelector('[data-variant-json]');
    if (dataEl) {
      var id = parseInt(form.querySelector('[name="id"]').value, 10);
      var match = JSON.parse(dataEl.textContent).find(function (v) { return v.id === id; });
      if (match) base = match.price;
    }
    var sum = addons.reduce(function (s, el) { return s + (parseInt(el.getAttribute('data-price'), 10) || 0); }, base) * qty;
    totalEl.hidden = false;
    totalEl.textContent = 'Total: ' + (window.MaguvaMoney ? window.MaguvaMoney({ price: sum }) : (sum / 100).toFixed(2));
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (e.target.matches('input[data-addon-toggle]')) {
      var box = document.getElementById(e.target.getAttribute('data-addon-toggle'));
      if (box) box.querySelectorAll('input[data-addon-variant]').forEach(function (r) { r.disabled = !e.target.checked; });
    }
    updateAddonTotal(form);
  });

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('form[data-quick-add], form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      var addons = form.hasAttribute('data-product-form') ? selectedAddons(form) : [];
      var res;
      if (addons.length) {
        var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        var items = [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: qty }];
        addons.forEach(function (a) {
          items.push({
            id: parseInt(a.getAttribute('data-variant-id'), 10),
            quantity: qty,
            properties: { 'For': form.getAttribute('data-product-title') || '' }
          });
        });
        res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
      } else {
        var body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);
        res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        });
      }
      var data = await res.json();
      if (res.ok) {
        if (data.sections) renderDrawerFromSection(data.sections['cart-drawer']);
        await syncCart();
        openDrawer('CartDrawer');
        if (btn) btn.textContent = 'Added ✓';
      } else {
        if (btn) btn.textContent = (data && data.description) ? 'Unavailable' : 'Error';
      }
    } catch (err) {
      if (btn) btn.textContent = 'Error';
    } finally {
      setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
    }
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- PDP variant selection ---- */
  document.querySelectorAll('[data-variant-selects]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    function update() {
      var chosen = Array.from(root.querySelectorAll('.variant-pill input:checked')).map(function (i) { return i.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      var idInput = root.querySelector('[name="id"]');
      if (idInput) idInput.value = match.id;
      var priceEl = root.querySelector('[data-pdp-price]');
      if (priceEl && window.MaguvaMoney) priceEl.innerHTML = window.MaguvaMoney(match);
      var btn = root.querySelector('[data-add-btn]');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute('data-add-label') : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('.variant-pill input')) update();
    });
  });

  /* ---- Sticky header hide on scroll down ---- */
  var lastY = 0, header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.style.transform = (y > lastY && y > 200) ? 'translateY(-100%)' : 'translateY(0)';
      header.style.transition = 'transform 0.4s cubic-bezier(0.22,1,0.36,1)';
      lastY = y;
    }, { passive: true });
  }
})();
